/**
 * Interfaces
 */
import React, { Fragment } from 'react';
import * as Interfaces from './interfaces';
import {
  ADJUSTMENT_KEYS,
  ARROW_POSITION,
  INPUT_KEYS,
  INSTRUCTION_STEP,
  MIX_ADJUSTMENT_DEFAULT,
  PATHS,
  TRANSFORMATION_KEYS,
} from './constants';
import {
  ICON_SOUNDSENSING,
  ICON_SOUNDBARS,
  ICON_HEADPHONE,
  ICON_SOUND,
  ICON_STAR,
  ICON_LIGHTBULB_FILLED,
  ICON_WIFI,
  ICON_BELL,
} from './icons';
import { Add, Cancel, Tune } from '@material-ui/icons';

export const DEFAULT_AUDIO_ADJUSTMENT_MAP: Interfaces.AudioAdjustmentMap = {
  [INPUT_KEYS.ACAPELLA]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: -5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 10,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
  },
  [INPUT_KEYS.BIRDS]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 10,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 1,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
  },
  [INPUT_KEYS.CARNATIC_SINGING]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: -1,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 10,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
  },
  [INPUT_KEYS.CELLO]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 10,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: -1,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
  },
  [INPUT_KEYS.POTS_AND_PANS]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: -1,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 1,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 10,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: -1,
    },
  },
  [INPUT_KEYS.SYNTHESIZER]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: -5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 10,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: -5,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
  },
  [INPUT_KEYS.RECORD]: {
    [TRANSFORMATION_KEYS.FLUTE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TENOR_SAXOPHONE]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.TRUMPET]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
    [TRANSFORMATION_KEYS.VIOLIN]: {
      [ADJUSTMENT_KEYS.LOUDNESS]: 0,
      [ADJUSTMENT_KEYS.MIX]: MIX_ADJUSTMENT_DEFAULT,
      [ADJUSTMENT_KEYS.OCTAVE]: 0,
    },
  },
};

export const INPUTS: Map<
  string,
  Interfaces.MusicalEntity | Interfaces.RecordMenuItem
> = new Map([
  [
    INPUT_KEYS.ACAPELLA,
    {
      descriptor: 'Acapella',
      label: 'singing',
      tooltip: 'An excerpt from a solo singer who is classically trained',
    },
  ],
  [
    INPUT_KEYS.BIRDS,
    {
      descriptor: 'Birds',
      label: 'chirping',
      tooltip: 'The sound of several zebra finches chirping',
    },
  ],
  [
    INPUT_KEYS.CARNATIC_SINGING,
    {
      descriptor: 'Carnatic',
      label: 'singing',
      tooltip:
        'A style of music associated with southern India. In this improvisation, the singer bends between pitches.',
    },
  ],
  [
    INPUT_KEYS.CELLO,
    {
      descriptor: 'Cello',
      label: 'performing',
      tooltip: 'An improvisation on cello with long gliding melodies',
    },
  ],
  [
    INPUT_KEYS.POTS_AND_PANS,
    {
      descriptor: 'Pots and pans',
      label: 'clanging',
      tooltip:
        'Tone Transfer works on all sorts of sounds, pots and pans included',
    },
  ],
  [
    INPUT_KEYS.SYNTHESIZER,
    {
      descriptor: 'Synthesizer',
      label: 'riffing',
      tooltip: 'A fun synth straight from the dance floor',
    },
  ],
  [
    INPUT_KEYS.RECORD,
    {
      isLoaded: true,
      noRecording: {
        icon: <Add />,
        descriptor: 'Add your own',
      },
      hasRecording: {
        icon: <Cancel />,
        descriptor: 'Your recording',
      },
    },
  ],
]);

export const ARROWS: Map<string, Interfaces.Arrow> = new Map([
  [
    ARROW_POSITION.LEFT,
    {
      headCoordinates: [0, 0],
      headPath: [
        [16, -16],
        [0, 0],
        [16, 16],
      ],
      linePath: [
        [0, 0],
        [8, 8],
        [18, 40],
        [35, 65],
        [40, 100],
      ],
      mobileArrowPosition: ARROW_POSITION.TOP,
    },
  ],
  [
    ARROW_POSITION.RIGHT,
    {
      headCoordinates: [100, 0],
      headPath: [
        [-16, -16],
        [0, 0],
        [-16, 16],
      ],
      linePath: [
        [100, 0],
        [92, 8],
        [82, 40],
        [65, 65],
        [60, 100],
      ],
      mobileArrowPosition: ARROW_POSITION.TOP,
    },
  ],
  [
    ARROW_POSITION.BOTTOM,
    {
      headCoordinates: [50, 100],
      headPath: [
        [-16, -16],
        [0, 0],
        [16, -16],
      ],
      linePath: [
        [49, 0],
        [48, 30],
        [50, 70],
        [50, 100],
      ],
    },
  ],
  [
    ARROW_POSITION.TOP,
    {
      headCoordinates: [50, 0],
      headPath: [
        [-16, 16],
        [0, 0],
        [16, 16],
      ],
      linePath: [
        [50, 0],
        [50, 25],
        [48, 50],
        [50, 75],
        [50, 100],
      ],
    },
  ],
]);

export const INSTRUCTIONS: Map<string, Interfaces.Instruction> = new Map([
  [
    INSTRUCTION_STEP.NO_INPUT_SELECTED,
    {
      arrowPosition: ARROW_POSITION.LEFT,
      text: {
        primary: 'Start experimenting by selecting an input',
      },
    },
  ],
  [
    INSTRUCTION_STEP.NO_OUTPUT_SELECTED,
    {
      arrowPosition: ARROW_POSITION.RIGHT,
      text: {
        primary: 'Transform it into a totally different sound using ML',
      },
    },
  ],
  [
    INSTRUCTION_STEP.RECORD_START,
    {
      arrowPosition: ARROW_POSITION.BOTTOM,
      text: {
        primary: 'Record or upload a clip',
        post: '(Audio longer than 15 seconds will be trimmed)',
      },
    },
  ],
  [
    INSTRUCTION_STEP.RECORD_IN_PROGRESS,
    {
      text: {
        primary: (
          recordingTimeElapsed: number,
          maxRecSecs: string
        ): React.ReactElement => (
          <Fragment>
            <strong>
              0:
              {recordingTimeElapsed >= 10
                ? recordingTimeElapsed
                : `0${recordingTimeElapsed}`}{' '}
              /
            </strong>{' '}
            0:{maxRecSecs}
          </Fragment>
        ),
      },
    },
  ],
  [
    INSTRUCTION_STEP.RECORD_REVIEW,
    {
      arrowPosition: ARROW_POSITION.BOTTOM,
      text: {
        primary: 'Let’s review your recording',
      },
    },
  ],
  [
    INSTRUCTION_STEP.TRANSFORMATION_IN_PROGRESS,
    {
      arrowPosition: ARROW_POSITION.RIGHT,
      text: {
        primary: 'We are transforming your recording using ML',
        post: '(It will be ready in a few seconds)',
      },
    },
  ],
  [
    INSTRUCTION_STEP.TRANSFORMATION_COMPLETE,
    {
      arrowPosition: ARROW_POSITION.RIGHT,
      text: {
        primary: 'Hear your recording in a totally different sound',
      },
    },
  ],
]);

export const INSTRUMENTS: Map<string, Interfaces.Instrument> = new Map([
  [
    TRANSFORMATION_KEYS.FLUTE,
    {
      color: '#81c995',
      backgroundColor: '#cfead7',
      descriptor: 'Concert',
      label: 'flute',
      tooltips: [
        {
          content:
            'This model is trained on recordings performed by a western concert flute, the most common variant of the flute. It is a transverse (side-blown) woodwind instrument commonly used in classical and jazz music',
          coordinates: { x: 20, y: 12 },
          title: 'The concert flute',
          icon: ICON_LIGHTBULB_FILLED,
        },
        {
          audioSource: `${PATHS.CURATED_AUDIO}/training_data/flute.mp3`,
          coordinates: { x: 62, y: 53 },
          content:
            'Listen to a sample of the original 10 minute recording used to train this flute model.',
          title: 'Original training data',
          icon: ICON_SOUND,
        },
        {
          content:
            'Hear the model recreate breathing sounds particular to this flutist from the training data.',
          coordinates: { x: 86, y: 78 },
          title: 'What makes this model special',
          icon: ICON_STAR,
        },
      ],
    },
  ],
  [
    TRANSFORMATION_KEYS.TENOR_SAXOPHONE,
    {
      color: '#e8710a',
      backgroundColor: '#fae1cb',
      descriptor: 'Concert tenor',
      label: 'saxophone',
      tooltips: [
        {
          content:
            'This model is trained on recordings of a tenor saxophone performing jazz music. The tenor saxophone has been an important solo instrument in jazz music.',
          coordinates: { x: 20, y: 7 },
          title: 'The tenor saxophone',
          icon: ICON_LIGHTBULB_FILLED,
        },
        {
          audioSource: `${PATHS.CURATED_AUDIO}/training_data/tenor_saxophone.mp3`,
          content:
            'Listen to a sample of the original 10 minute recording used to train this saxophone model.',
          coordinates: { x: 62, y: 77 },
          title: 'Original training data',
          icon: ICON_SOUND,
        },
        {
          content:
            'Listen how the model recreates the sound of buttons being pressed that it extracted from the training data.',
          coordinates: { x: 86, y: 53 },
          title: 'What makes this model special',
          icon: ICON_STAR,
        },
      ],
    },
  ],
  [
    TRANSFORMATION_KEYS.TRUMPET,
    {
      color: '#ee675c',
      backgroundColor: '#fdd2cf',
      descriptor: 'Improvisational Jazz',
      label: 'trumpet',
      tooltips: [
        {
          content:
            'This model is trained on recordings of trumpet playing jazz music. The trumpet is a brass instrument commonly used in orchestras, concert bands, jazz ensembles, and popular music.',
          coordinates: { x: 4, y: 75 },
          title: 'The jazz trumpet',
          icon: ICON_LIGHTBULB_FILLED,
        },
        {
          audioSource: `${PATHS.CURATED_AUDIO}/training_data/trumpet.mp3`,
          content:
            'Listen to a sample of the original 10 minute recording used to train this trumpet model.',
          coordinates: { x: 51, y: 64 },
          title: 'Original training data',
          icon: ICON_SOUND,
        },
        {
          content:
            'This model recreates the tone of the trumpet mixed with the player’s breathing sounds.',
          coordinates: { x: 85, y: 20 },
          title: 'What makes this model special',
          icon: ICON_STAR,
        },
      ],
    },
  ],
  [
    TRANSFORMATION_KEYS.VIOLIN,
    {
      color: '#a142f4',
      backgroundColor: '#e7d4f7',
      descriptor: 'Classical',
      label: 'violin',
      tooltips: [
        {
          content:
            'This model is trained on recordings of a violin performing classical music. The violin is extremely agile and can execute difficult sequences of notes, making it appropriate for playing solo.',
          coordinates: { x: 43, y: 19 },
          title: 'The classical violin',
          icon: ICON_LIGHTBULB_FILLED,
        },
        {
          audioSource: `${PATHS.CURATED_AUDIO}/training_data/violin.mp3`,
          content:
            'Listen to a sample of the original 10 minute recording used to train this violin model.',
          coordinates: { x: 79, y: 61 },
          title: 'Original training data',
          icon: ICON_SOUND,
        },
        {
          content:
            'This model recreates bowing sounds it extracted from the training data.',
          coordinates: { x: 14, y: 75 },
          title: 'What makes this model special',
          icon: ICON_STAR,
        },
      ],
    },
  ],
]);

export const MOBILE_TIPS = [
  {
    icon: ICON_BELL,
    title: 'Turn off Silent Mode',
    content:
      'If you are using an iOS device, turn off Silent Mode to hear the audio playback.',
  },
  {
    icon: ICON_WIFI,
    title: 'Connect to WiFi',
    content:
      'This website downloads audio and machine learning models. To save your mobile data, connect your device to WiFi.',
  },
];

export const RECORDING_TIPS = [
  {
    icon: ICON_SOUNDSENSING,
    title: 'Try long soaring melodies',
    content: 'Enunciate the lyrics if you are singing',
  },
  {
    icon: ICON_SOUNDBARS,
    title: 'Play one note at a time',
    content: 'Our model currently doesn’t work with chords',
  },
  {
    icon: ICON_HEADPHONE,
    title: 'Reduce background noise',
    content: 'Use a microphone or headphones if possible',
  },
  {
    icon: <Tune style={{ transform: 'rotate(90deg)' }} />,
    title: 'Adjust your transformations later',
    content:
      'When your transformations are ready, adjust them for desired results',
  },
];

export const RECORDER_FOOTER_BUTTON = {
  [INSTRUCTION_STEP.RECORD_START]: 'Record',
  [INSTRUCTION_STEP.RECORD_IN_PROGRESS]: 'Done',
  [INSTRUCTION_STEP.RECORD_REVIEW]: 'Transform',
};

export const TRANSFORMATION_PROGRESS = {
  0: '',
  1: 'Processing your recording',
  2: 'Updating transformations',
  3: 'Transformation complete',
};

export const MESSAGES = {
  ACTIONS_CANCEL: 'Cancel',
  ACTIONS_CLOSE: 'Close',
  ACTIONS_DELETE: 'Delete',
  ACTION_ACKNOWLEDGE: 'Got it',
  ACTION_CANCEL: 'Cancel',
  ACTION_COPY: 'Copy to clipboard',
  ACTION_COPIED: 'Link copied',
  ACTION_PLAY: 'Play',
  ACTION_PAUSE: 'Pause',
  ACTION_TIPS: 'Tips',
  ACTION_UPLOAD: 'Upload',
  ADJUSTMENTS_HEADING_TOOLTIP_TITLE: 'Adjust your transformations',
  ADJUSTMENTS_HEADING_TOOLTIP: (
    <p>
      You can adjust your transformations to sound more realistic. This
      experiment is built with DDSP.js, the on-device version. Our cloud version
      generates better audio ouputs and provides more adjustment options. You
      can try out the cloud version in our{' '}
      <a target="_blank" rel="noopener noreferrer" href={PATHS.COLAB}>
        Colab demo
      </a>
      .
    </p>
  ),
  ADJUSTMENTS_HEADING_LOUDNESS: 'Adjust loudness',
  ADJUSTMENTS_HEADING_MIX: 'Blend input and output',
  ADJUSTMENTS_HEADING_OCTAVE: 'Adjust octave',
  ADJUSTMENTS_DESCRIPTION_LOUDNESS:
    'Make the ML output quieter if you hear too much background noise and louder if you can’t hear some notes in your recording.',
  ADJUSTMENTS_DESCRIPTION_MIX: 'Blend between the original input and ML output',
  ADJUSTMENTS_DESCRIPTION_OCTAVE:
    'For a better ML output, adjust the octave range of your recording to be similar to that of the instrument. For example, make the octave higher for the violin and lower for the saxophone.',
  ADJUSTMENTS_DIALOG_HEADING: 'Adjust %KEY% ML output',
  ADJUSTMENTS_DIALOG_DESCRIPTION: 'Fine tune how your transformation sounds',
  ADJUSTMENTS_DIALOG_LOADING: 'Adjustments will be ready in a few seconds',
  ADJUSTMENTS_DIALOG_UNSUPPORTED:
    'To adjust octave and loudness values, checkout Tone Transfer on Chrome on your desktop or Android.',
  ADJUSTMENTS_BUTTON_ARIA_LABEL: 'Fine tune how your transformation sounds',
  ADJUSTMENTS_TOOLTIP: 'Fine tune how your transformation sounds',
  ADJUSTMENTS_MIX: 'Mix',
  ADJUSTMENTS_OCTAVE: 'Octave',
  ADJUSTMENTS_LOUDNESS: 'Loudness',
  ADJUSTMENTS_MIX_LOWER: 'Decrease output mix',
  ADJUSTMENTS_MIX_HIGHER: 'Increase output mix',
  ADJUSTMENTS_OCTAVE_LOWER: 'Lower octave',
  ADJUSTMENTS_OCTAVE_HIGHER: 'Higher octave',
  ADJUSTMENTS_LOUDNESS_LOWER: 'Decrease loudness',
  ADJUSTMENTS_LOUDNESS_HIGHER: 'Increase loudness',
  BROWSER_ERROR_HEADING:
    'Whoops... Tone Transfer is not supported in your browser',
  BROWSER_ERROR_DESCRIPTION:
    'You are seeing this page because we detected an unsupported browser for Tone Transfer. To experiment with Tone Transfer and a new way of music making, update your browser to the latest version. ',
  BROWSER_ERROR_SUBHEADING: 'Update your browser',
  BROWSER_ERROR_NOTICE:
    'The download is safe from the vendor’s official website',
  BROWSER_ERROR_CHROME: 'Google Chrome',
  BROWSER_ERROR_EDGE: 'Microsoft Edge',
  BROWSER_ERROR_FIREFOX: 'Mozilla Firefox',
  BROWSER_ERROR_DOWNLOAD: 'Download %BROWSER%',
  CONTROLS_ABOUT_INPUT: 'About the %INPUT% input',
  CONTROLS_INPUT: 'Input',
  CONTROLS_INPUTS_ARIA_LABEL: 'Select an audio input',
  CONTROLS_TRANSFORMATION: 'Transformation',
  CONTROLS_OUTPUTS_ARIA_LABEL:
    'Select a transformation to apply to your selected input',
  CONTROLS_INPUT_BUTTON_ARIA_LABEL: 'Select %INPUT% input',
  CONTROLS_OUTPUT_BUTTON_ARIA_LABEL: 'Transform selected input into %OUTPUT%',
  CONTROLS_PLACEHOLDER_SELECT_INPUT: 'Select an input',
  CONTROLS_PLACEHOLDER_SELECT_OUTPUT: 'Select a transformation',
  COOKIEBAR_ACCEPT: 'OK, Got it.',
  COOKIEBAR_DESCRIPTION:
    'This site uses cookies from Google to deliver its services and to analyze traffic.',
  COOKIEBAR_LEARN_MORE: 'Learn more',
  DELETE_RECORDING_HEADING: 'Delete your recording?',
  DELETE_RECORDING_ARIA_LABEL: 'Delete this recording and start new',
  DELETE_RECORDING_DESCRIPTION:
    'This action will delete your recording and its transformations. You can download these audios before deleting. After you’ve deleted your recording, you can record or upload a new one.',
  DOWNLOAD_DIALOG_BUTTON_ARIA_LABEL: 'Download recording and transformations',
  DOWNLOAD_DIALOG_DESCRIPTION: (
    <p>
      Now that you’ve created your own unique ML music, download and share it
      with your friends! Share your creations with the{' '}
      <a
        href="https://twitter.com/search?q=%23tonetransfer"
        target="_blank"
        rel="noopener noreferrer"
      >
        #ToneTransfer
      </a>{' '}
      hashtag.
    </p>
  ),
  DOWNLOAD_DIALOG_HEADING: 'Download and share',
  DOWNLOAD_ADJUSTED: '(adjusted)',
  DOWNLOAD_ORIGINAL_ARIA_LABEL: 'Download your recording',
  DOWNLOAD_ORIGINAL_LABEL: 'Your recording',
  DOWNLOAD_ARIA_LABEL: 'Download %KEY% transformation',
  DOWNLOAD_LABEL: '%KEY% transformation',
  DOWNLOAD_SHARE: 'Like our website? Share it with others.',
  FOOTER_CTA: 'Discover more',
  FOOTER_FRAME_TITLE: 'About Tone Transfer',
  IMAGE_ALT_MAGENTA_LOGO: 'Magenta Logo',
  IMAGE_ALT_TONE_TRANSFER_LOGO: 'Tone Transfer Logo',
  IMAGE_ALT_GOOGLE_LOGO: 'Google Research Logo',
  INTRO_SKIP: 'Skip intro',
  INTRO_VIGNETTE_OVERLAY_1:
    'Google and the Magenta team collaborated with musicians around the world to turn their instrumental performances into machine learning models.',
  INTRO_VIGNETTE_OVERLAY_2:
    'Now, using these ML models, anyone can make music in a variety of forms and hear what it would accurately sound like performed as another instrument.',
  INTRO_VIGNETTE_OVERLAY_3:
    'With the Tone Transfer experiment, you can explore, create, and share unique musical combinations and creations that were never truly possible before.',
  INTRO_WATCH_VIDEO: 'Watch short video',
  LANDING_DESCRIPTION:
    'Mix and match music and machine learning to unlock new sounds',
  LANDING_BUTTON: 'Let’s play!',
  MOBILE_TIPS_HEADING: 'Tips for Tone Transfer',
  OUTPUT_NONE: 'None',
  RECORDER_MIC_ACCESS_DESCRIPTION:
    'Tone Transfer has been blocked from using your microphone.',
  RECORDER_MIC_ACCESS_LINK: 'Learn more',
  RECORDER_MIC_ACCESS_PROMPT:
    'Please enable microphone access again to use the recording feature.',
  RECORDER_MIC_ACCESS_PROMPT_WITH_LINK: '%LINK% about how to allow access.',
  RECORDER_UNSUPPORTED_WEBGL:
    'This feature requires webgl to be enabled on the browser. Please try another browser or device.',
  RECORDER_TRANSFORMING: 'Transforming your recording - ',
  RECORDER_TRANSFORMATION_COMPLETE: 'Transformation Complete',
  RECORDER_MEMORY_CHECK_DIALOG_TITLE: 'Checking device compatibility',
  RECORDER_PROCESSING_DIALOG_CONTENT_NOT_COMPATIBLE_TITLE:
    'Your device is not compatible',
  RECORDER_PROCESSING_DIALOG_CONTENT_NOT_COMPATIBLE:
    'We detected that your device is not compatible with the “Add your own” feature. You can go back to the website and continue experimenting with other features.',
  RECORDER_PROCESSING_DIALOG_TITLE: 'Processing your recording',
  RECORDER_PROCESSING_DIALOG_CONTENT:
    'Don’t go away, processing will be faster if you stay on this tab.',
  ROTATE_SCREEN_DESCRIPTION:
    'For the best experience on this website, rotate your phone to the portrait (vertical) mode.',
  ROTATE_SCREEN_HEADING: 'Rotate your phone',
  RECORDING_TIPS_HEADING: 'Tips for “Add your own”',
  [INSTRUCTION_STEP.RECORD_IN_PROGRESS]: 'Recording in progress',
  [INSTRUCTION_STEP.RECORD_REVIEW]:
    'Like what you hear? Transform your recording to other sounds using ML when you are ready! It takes about 20 seconds depending on your recording length and device.',
  [INSTRUCTION_STEP.RECORD_START]:
    'Your recording will be transformed in your browser and no personally identifiable information is collected or stored.',
  [INSTRUCTION_STEP.TRANSFORMATION_IN_PROGRESS]: 'Transformation in progress',
  [INSTRUCTION_STEP.TRANSFORMATION_COMPLETE]: 'Transformation complete',
  UNSUPPORTED_SAMPLE_RATE_HEADING: 'Unsupported output device',
  UNSUPPORTED_SAMPLE_RATE_TEXT:
    'It looks like your output device has a sample rate of less than 44,100Hz. Please switch to an output device that supports at least 44,100Hz. ',
};
